module.exports = __webpack_public_path__ + "img/desk2.01db3253.png";